import { buttonVariants } from '@/components/ui/button';
import { SheetClose, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { useGetReleaseNotes } from '@/lib/contentful';
import { XIcon } from 'lucide-react';
import { ReleaseNote } from './release-note';
import { ReleaseNoteErrorBoundary } from './release-note-error-boundary';

export function ReleaseNotesSheetContent() {
  const { data: releaseNotes } = useGetReleaseNotes();

  return (
    <>
      <SheetHeader className='flex-row justify-between px-4 pt-4'>
        <SheetTitle>Release notes</SheetTitle>
        <SheetClose
          className={buttonVariants({
            variant: 'ghost',
            size: 'icon-sm',
          })}
        >
          <XIcon className='size-4' />
        </SheetClose>
      </SheetHeader>

      <div className='flex h-full flex-col gap-6 overflow-y-auto px-4 pt-4'>
        {releaseNotes
          ?.sort((a, b) => b.date.getTime() - a.date.getTime())
          .map((note) => (
            <ReleaseNoteErrorBoundary key={note.id} noteId={note.id}>
              <ReleaseNote note={note} />
            </ReleaseNoteErrorBoundary>
          ))}
      </div>
    </>
  );
}
